import { IPhongBan } from "../../../model/respone/category/IPhongBan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhongBanActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IPhongBan[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IPhongBan | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IPhongBan,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const ePhongBanActionIds = generateActionTypeIds(ePhongBanActionsObj, "PHONG_BAN");
export type IPhongBanActionTypes = IGenericActionType<typeof ePhongBanActionsObj, "PHONG_BAN">;
